
import { SECURITY_CONFIG, VALIDATION_PATTERNS } from './security-constants';

export interface AuthSecurityContext {
  userId: string;
  subscriptionTier: string;
  sessionValid: boolean;
}

export class AuthSecurityValidator {
  static validateUserId(userId: string): boolean {
    if (!userId) return false;
    
    // Validate UUID format
    return VALIDATION_PATTERNS.UUID.test(userId);
  }
  
  
  static sanitizeInput(input: string, maxLength: number = SECURITY_CONFIG.MAX_INPUT_LENGTH): string {
    if (!input) return '';
    
    return input
      .trim()
      .slice(0, maxLength)
      .replace(VALIDATION_PATTERNS.SAFE_HTML, '')
      .replace(/javascript:/gi, '')
      .replace(/on\w+\s*=/gi, '');
  }
  
  static validateThreadAccess(userId: string, threadOwnerId: string): boolean {
    // Users can only access their own threads
    return userId === threadOwnerId;
  }
  
  static createSecurityContext(
    userId: string, 
    email?: string, 
    subscriptionTier = 'free'
  ): AuthSecurityContext {
    return {
      userId,
      subscriptionTier,
      sessionValid: this.validateUserId(userId)
    };
  }

  // Enhanced method to validate database access with better debugging
  static validateDatabaseAccess(currentUserId: string, resourceUserId: string): boolean {
    if (!currentUserId || !resourceUserId) {
      return false;
    }
    
    // Enhanced comparison with type checking and normalization
    const normalizedCurrentId = String(currentUserId).trim();
    const normalizedResourceId = String(resourceUserId).trim();
    
    return normalizedCurrentId === normalizedResourceId;
  }
}
